import { Component, OnInit } from '@angular/core';
declare var $: any;


@Component({
  selector: 'app-w-twothree-twofour',
  templateUrl: './w-twothree-twofour.component.html',
  styleUrls: ['./w-twothree-twofour.component.scss']
})
export class WTwothreeTwofourComponent implements OnInit {
 pdfSrc: string[] = [
    'https://drive.google.com/file/d/1AiivZt9Z_hoYUZ5QZ8zQkoeyu5aWfONK/preview', 
    'https://drive.google.com/file/d/192EWOvazMKtOmdZnUcA9Qtg25ceg4vro/preview',];
  src: string;
  isLoading = true;
  ngOnInit(): void {
    this.changeRoute('1');
  }

  changeRoute(year: string) {
    this.isLoading = true;
    if (year == '1') {
      $('.first').addClass('active');
      $('.second').removeClass('active');
      this.src = this.pdfSrc[0];
    }
    if (year == '2') {
      $('.second').addClass('active');
      $('.first').removeClass('active');
      this.src = this.pdfSrc[1];
    }
  }
  hideLoader() {
    this.isLoading = false;
  }
}
